import type { Messages } from '../de';

export default {
  page: {
    kicker: 'Monthly and yearly review',
    title: 'Wrapped',
    periodsFailed: 'Could not load periods: {error}',
    ready: 'Ready to watch',
    running: 'In progress',
    teaserTitle: 'Your {label}',
    teaserText: { one: '{count} session – told in a few slides.', other: '{count} sessions – told in a few slides.' },
    watch: 'Watch review',
    all: 'All reviews',
    periodTabs: 'Period',
    months: 'Months',
    years: 'Years',
    loading: 'Loading …',
    loadFailed: 'This review could not be loaded: {error}',
    loadFailedPlain: 'This review could not be loaded.',
    packing: 'Packing your review …',
    close: 'Close',
    year: 'Year {year}',
    sessions: { one: '{count} session', other: '{count} sessions' },
    periodAria: '{label}, {count} sessions',
    periodAriaRunning: '{label}, {count} sessions, in progress',
    badgeRunning: 'in progress',
  },
  story: {
    prev: 'Previous slide',
    next: 'Next slide',
    close: 'Close Wrapped',
    slideOf: 'Slide {n} of {total}',
    progress: 'Progress',
    tapClose: 'Tap to close',
    tapNext: 'Tap to continue',
    saveAria: 'Save slide {n} as image',
    saving: 'Saving …',
    saveFailed: 'Failed – try again',
    save: 'Save as image',
    srSlide: 'Slide {n} of {total}: {label}',
  },
  slides: {
    kickerYour: 'Your {label}',
    runningSuffix: ' · in progress',
    sportsOne: 'All about {sport}.',
    sportsMostly: 'Mostly {sport}.',
    sportsMany: '{count} sports {in}.',
    sportsText: '{sport} took {pct} of your training time – {sessions}.',
    sessions: { one: '{count} session', other: '{count} sessions' },
    kickerSports: 'Your sports · {short}',
    hours: 'Hours',
    heartbeats: 'Around {n} heartbeats in training.',
    kickerRhythm: 'Your rhythm · {short}',
    favorite: 'Favourite start',
    weekdayInitials: 'MTWTFSS',
    streakWeeksUnit: 'weeks active in a row.',
    activeDay: 'active day.',
    activeDays: 'active days.',
    weekStreak: 'Your weekly streak',
    outIn: 'Out and about {in}',
    kickerStreak: 'Your streak · {short}',
    longestTitle: 'Your longest session',
    atTime: '{day}, {time}',
    longestLabel: 'Your longest session: {text}',
    kickerSuperlatives: 'Superlatives · {short}',
    records: { one: 'One new personal best.', other: '{count} new personal bests.' },
    firsts: { one: 'A first.', other: '{count} firsts.' },
    before: 'before {prev} · {day}',
    firstTime: 'FIRST TIMES',
    kickerRecords: 'Personal bests · {short}',
    races: { one: 'One race.', other: '{count} races.' },
    racesPb: { one: 'One new personal best.', other: '{count} new personal bests.' },
    kickerRaces: 'Races · {short}',
    raceDnf: 'did not finish',
    racePb: 'PB',
    raceWatch: '~ = time from the watch',
    raceMore: { one: '+ one more', other: '+ {count} more' },
    bestNight: 'Your best night',
    recovery: 'Your recovery',
    sleepHours: 'hours of sleep',
    score: ' · score {score}',
    highestHrv: 'highest HRV',
    lowestRhr: 'lowest resting HR',
    stepsPerDay: 'steps per day',
    avgSleep: 'avg sleep',
    kickerHealth: 'Recovery · {short}',
    overYears: '{short} over the years',
    yearByYear: 'Year by year',
    beforeNow: 'Before and now',
    hoursCaps: 'HOURS',
    kickerCompare: 'Compared · {short}',
    routesTitle: 'Your routes {in}.',
    routesText: {
      one: 'Your longest route – no map, start and finish stay private.',
      other: 'Your {count} longest routes – no map, start and finish stay private.',
    },
    routesLabel: 'Route collage with {count} routes {in}, without start and finish.',
    kickerRoutes: 'Routes · {short}',
    photosTitle: 'Moments {in}.',
    photosLabel: { one: '{count} photo {in}.', other: '{count} photos {in}.' },
    kickerPhotos: 'Photos · {short}',
    totalKm: '{km} km in total. {eq}',
    emptyPause: '{in} you took a break.',
    emptyStarted: '{label} has only just begun.',
    emptyPauseText: 'No activity recorded – breaks are part of it too. The next review is already waiting.',
    emptyStartedText: 'No activity recorded yet. Check back once you have been out.',
  },
} satisfies Messages['wrapped'];
